import { Provider } from '@angular/core';
import { EmailDataHttpService } from './abstract';
import { EmailDataHttpServiceImpl } from './email-data-http.service';

export const EmailDataHttpProvider: Provider = {
	provide: EmailDataHttpService,
	useClass: EmailDataHttpServiceImpl,
};
